import React from 'react';
import 'styles/components/menu/research/CoreTechnologyTab.scss';
import researchAI from 'assets/data/researchAI.json';
import researchAR from 'assets/data/researchAR.json';
import AI from 'assets/images/research/AI.png';
import AR from 'assets/images/research/AR_tech.PNG';
import styled from 'styled-components';

const Img = styled.div`
    width: 100%;
    height: 0;
    padding-top: calc(${props => props.height} / ${props => props.width} * 100%);
    background : url(${props => props.src}) center left / cover no-repeat;
    margin-bottom: 2rem;
`;

const CoreTechnologyTab = () => {
    return (
        <section className='CoreTechnologyTab'>
            <div className="CoreTechnologyTab-wrapper">
                <div className="research">
                    <div className="title">
                        인공지능(AI) 융합 기술 연구
                    </div>
                    <div className="content">
                        {researchAI.map((item, idx) => <p key={idx}>{item}</p>)}
                    </div>
                    <div className="img">
                        <Img src={AI} width={1030} height={560} />
                    </div>
                </div>
                <div className="research">
                    <div className="title">
                        위치기반 증강현실(AR) 서비스 플랫폼 연구
                    </div>
                    <div className="content">
                        {researchAR.map((item, idx) => <p key={idx}>{item}</p>)}
                    </div>
                    <div className="img">
                        <Img src={AR} width={1454} height={940} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CoreTechnologyTab;